import { render, staticRenderFns } from "./OrganizerMessageList.vue?vue&type=template&id=00696f56&scoped=true"
import script from "./OrganizerMessageList.vue?vue&type=script&lang=js"
export * from "./OrganizerMessageList.vue?vue&type=script&lang=js"
import style0 from "./OrganizerMessageList.vue?vue&type=style&index=0&id=00696f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00696f56",
  null
  
)

export default component.exports